module.exports = __webpack_public_path__ + "static/media/picto-tribes-black.64574a45.svg";